import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import WarehouseApiIdentFormik from './WarehouseApiIdentFormik';

interface WarehouseApiIdentOffcanvasProps {
    show: boolean;
    setShow: (show: boolean) => void;
    warehouseId: number;
    warehouseIdApi?: string | null;
    onSaved: () => Promise<void>;
}

const WarehouseApiIdentOffcanvas = ({
    show,
    setShow,
    warehouseId,
    warehouseIdApi,
    onSaved,
}: WarehouseApiIdentOffcanvasProps) => {
    const { t } = useTranslation(['Warehouses']);

    const handleClose = () => setShow(false);

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title>{t('apiIdent.title')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <WarehouseApiIdentFormik
                    setShow={setShow}
                    warehouseId={warehouseId}
                    warehouseIdApi={warehouseIdApi}
                    onSaved={onSaved}
                />
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default WarehouseApiIdentOffcanvas;
